<div class="outer-div">
<div id="loginScreen" class="inner-div">
<div class="inner-inner-div">

	<h2>LOGIN</h2>
    <p>({{message}})</p>
    
	<div>
		<table>
		<tr>
			<td><label for="userName">User name: </label></td>
			<td><input type="text" id="userName" (keyup.enter)="login()" [(ngModel)]="userName"></td>
		</tr>
		<tr>
			<td><label for="userPassword">Password: </label></td>
			<td><input pPassword pInputText type="password" id="userPassword" (keyup.enter)="login()" [(ngModel)]="userPassword" size="20"></td>
			<td><span id="passwordToggle" class="fa fa-fw fa-eye field-icon toggle-password" [ngClass]="{'fa-eye-slash':showPassword}" (click)="togglePassword()"></span></td>
		</tr>
		</table>

		@if ( !authService.isLoggedIn ) {
		<input type="button" id="loginButton" (click)="login()"  value="Login" >
		} @else if ( authService.isLoggedIn ) {
		<input type="button" (click)="logout()" value="Logout" >
		}


	</div>

</div> 
</div>
</div>